// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__4edRx","sectionHeader":"Carousel_sectionHeader__GmSRM"};